import Container from './Container';
import View from './View';

export * from './utils';
export * from './components';

export default Container(View);
